<template>
	<el-container>
		<el-main>
			<el-row class='setpage'>
				<el-col :span="8">
					<div class="grid-content bg-purple-dark">开关机功能</div>
					<el-switch
						@change='powerChange'
					  style="display: block"
					  v-model="openDevice"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-text="验证权限"
					  inactive-text="不验证权限">
					</el-switch>
				</el-col>
			</el-row>
			<el-row class='setpage'>
				<el-col :span="8">
					<div class="grid-content bg-purple-dark">基础配置</div>
					<el-switch
						@change='powerChange'
					  style="display: block"
					  v-model="basics"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-text="验证权限"
					  inactive-text="不验证权限">
					</el-switch>
				</el-col>
				<el-col :span="8">
					<div class="grid-content bg-purple-dark">高级配置</div>
					<el-switch
						@change='powerChange'
					  style="display: block"
					  v-model="advanced"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-text="验证权限"
					  inactive-text="不验证权限">
					</el-switch>
				</el-col>
			</el-row>
			<el-row class='setpage'>
				<el-col :span="8">
					<div class="grid-content bg-purple-dark">产线校准</div>
					<el-switch
						@change='powerChange'
					  style="display: block"
					  v-model="production"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-text="验证权限"
					  inactive-text="不验证权限">
					</el-switch>
				</el-col>
				<el-col :span="8">
					<div class="grid-content bg-purple-dark">保留功能</div>
					<el-switch
						@change='powerChange'
					  style="display: block"
					  v-model="retain"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-text="验证权限"
					  inactive-text="不验证权限">
					</el-switch>
				</el-col>
			</el-row>
		</el-main>
	</el-container>
</template>

<script>
	import util from '../common/js/util'
	import { setOrganPower,getOrganDetail} from '../api/api';
	export default {
    data() {
      return {
  		openDevice:false,
        basics: true,
        advanced: true,
        production:true,
        retain:true,
      }
    },
    methods: {
    	powerChange(){
    		let power={
    			openDevice:Number(this.openDevice),
		        basics: Number(this.basics),
		        advanced: Number(this.advanced),
		        production:Number(this.production),
		        retain:Number(this.retain),
		        organ_sysno:this.GLOBAL.organ_sysno
    		}
    		let para = Object.assign({}, power);
    		setOrganPower(para).then((res) => {
				if(res.data.data.result==1){
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					let para2=Object.assign({},{organ_upper_sysno:this.organDetail.upper_sysno})
					getOrganDetail(para2).then((res)=>{
						console.log(res.data)
						this.GLOBAL.organDetail.name=res.data.name
						this.GLOBAL.organDetail.organ_img=res.data.organ_img
						this.GLOBAL.organDetail.organ_imgbackground=res.data.organ_imgbackground
						this.GLOBAL.organDetail.organ_phone=res.data.organ_phone
						this.GLOBAL.organDetail.organ_sortname=res.data.organ_sortname
						this.GLOBAL.organDetail.power_verification=res.data.power
						this.showInit()
					})
				}else if(res.data.data.result==2){
					this.$message({
						message: '修改失败， 数据错误',
						type: 'error'
					});
				}else{
					this.$message({
						message: '修改失败，已有重复数据',
						type: 'error'
					});
				}
			});
    		console.log(power)
    	},
    	showInit(){
    		this.openDevice=!!this.GLOBAL.organDetail.power_verification.openDevice
			this.basics=!!this.GLOBAL.organDetail.power_verification.basics
			this.advanced=!!this.GLOBAL.organDetail.power_verification.advanced
			this.production=!!this.GLOBAL.organDetail.power_verification.production
			this.retain=!!this.GLOBAL.organDetail.power_verification.retain
    	}
    },
    created(){
    	console.log(this.GLOBAL.organDetail.power_verification)
		this.showInit()
	}
  };
</script>

<style slot-scope lang="scss">
	.setpage .el-col{
	    background-color: #84d7fd;
	    padding: 10px;
	    border-radius: 25px;
	    font-size: 16px;
	    margin: 20px;
        justify-content: center;
	    align-items: center;
	    display: flex;
	    flex-direction: column;
        box-shadow: 0 0 9px #888;
        color: #000;
    	font-weight: bold;
	}
	.setpage .el-col>div{
		margin-bottom: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/setMiniApp.vue